import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const DEFAULT_FAVICON = '/favicon.ico';

const BrandFaviconContext = createContext({ brandFavicon: DEFAULT_FAVICON });

export const useBrandFavicon = () => useContext(BrandFaviconContext);

const updateFaviconLink = (href) => {
  let link = document.querySelector('link[rel="icon"]');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = href;

  let appleLink = document.querySelector('link[rel="apple-touch-icon"]');
  if (!appleLink) {
    appleLink = document.createElement('link');
    appleLink.rel = 'apple-touch-icon';
    document.head.appendChild(appleLink);
  }
  appleLink.href = href;
};

export const BrandFaviconProvider = ({ children }) => {
  const [brandFavicon, setBrandFavicon] = useState(DEFAULT_FAVICON);

  const fetchBrandFavicon = useCallback(() => {
    axios.get(`${API}/cms/brand-favicon`)
      .then(res => {
        if (res.data.brand_favicon) {
          let faviconUrl = res.data.brand_favicon;
          if (faviconUrl.startsWith('/api/')) {
            faviconUrl = `${BACKEND_URL}${faviconUrl}`;
          }
          setBrandFavicon(faviconUrl);
          updateFaviconLink(faviconUrl);
        } else {
          setBrandFavicon(DEFAULT_FAVICON);
          updateFaviconLink(DEFAULT_FAVICON);
        }
      })
      .catch(() => {
        setBrandFavicon(DEFAULT_FAVICON);
        updateFaviconLink(DEFAULT_FAVICON);
      });
  }, []);

  useEffect(() => {
    fetchBrandFavicon();
  }, [fetchBrandFavicon]);

  return (
    <BrandFaviconContext.Provider value={{ brandFavicon, setBrandFavicon, DEFAULT_FAVICON, refreshBrandFavicon: fetchBrandFavicon, updateFaviconLink }}>
      {children}
    </BrandFaviconContext.Provider>
  );
};

export default BrandFaviconContext;
